import { motion } from "framer-motion";

const stats = [
  { value: "7%", label: "of AppSumo's active buyers" },
  { value: "44%", label: "of their revenue" },
  { value: "6,075", label: "buyers analyzed" },
];

export default function Pareto() {
  return (
    <section
      data-testid="pareto-section"
      className="relative py-12 lg:py-16 border-t border-white/[0.06]"
    >
      <div className="max-w-[1200px] mx-auto px-6 lg:px-12">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.7, ease: [0.16, 1, 0.3, 1] }}
          className="max-w-[820px] mb-14"
        >
          <div className="font-mono-label text-[#D4FF4A]/70 mb-6">
            Case study · AppSumo
          </div>

          <h2
            data-testid="pareto-heading"
            className="font-display text-white text-[38px] lg:text-[52px] font-semibold mb-8"
          >
            The marketing fundamental nobody acts on.
          </h2>

          <div className="space-y-5 text-lg text-[#D4D4D8] leading-[1.65]">
            <p>
              10% of your customers drive roughly half your revenue. You've known this since you
              read the book. But your marketing still treats them like everyone else.
            </p>
            <p className="text-[#A1A1AA]">
              At AppSumo, 7% of active buyers drove 44% of revenue in six months. 6,000 people.
              Named.
            </p>
          </div>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 32 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
          className="relative bg-[#0A0A0F] border border-white/[0.08] rounded-2xl p-8 lg:p-12 mb-16 overflow-hidden"
          data-testid="pareto-testimonial"
        >
          <div
            className="absolute top-0 right-0 w-[420px] h-[420px] pointer-events-none opacity-40"
            style={{
              background:
                "radial-gradient(circle at top right, rgba(212, 255, 74, 0.08) 0%, transparent 60%)",
            }}
          />

          <div className="relative">
            <div className="flex items-center gap-5 mb-8">
              <img
                src="/images/appsumo-logo.svg"
                alt="AppSumo"
                className="h-7 w-auto opacity-95"
              />
              <div className="h-5 w-px bg-white/10" />
              <div className="font-mono-label text-[#71717A] text-[10px]">
                ICPIntel analysis across 6,075 buyers
              </div>
            </div>

            <blockquote className="font-display text-white text-[26px] sm:text-[30px] lg:text-[38px] leading-[1.3] font-medium mb-10 max-w-[920px]">
              <span className="text-[#D4FF4A] mr-1">"</span>
              Seeing this ICP intel analysis was eye-opening for our marketing team to target the
              right people. It was like a cheat code for us.
              <span className="text-[#D4FF4A] ml-1">"</span>
            </blockquote>

            <div className="flex items-center gap-4">
              <img
                src="/images/noah-kagan.jpg"
                alt="Noah Kagan"
                className="w-12 h-12 rounded-full object-cover border border-white/10"
              />
              <div>
                <div className="text-white text-[15px] font-medium">Noah Kagan</div>
                <div className="text-[#A1A1AA] text-sm">Founder & CEO, AppSumo</div>
              </div>
            </div>
          </div>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 lg:gap-8 mb-10">
          {stats.map((stat, i) => (
            <motion.div
              key={stat.label}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-100px" }}
              transition={{ duration: 0.6, delay: i * 0.08, ease: [0.16, 1, 0.3, 1] }}
              className="relative pl-6 border-l border-[#D4FF4A]/50 py-2"
              data-testid={`pareto-stat-${i}`}
            >
              <div className="font-display text-[#D4FF4A] text-[72px] lg:text-[88px] font-semibold leading-none tracking-tight mb-3">
                {stat.value}
              </div>
              <div className="text-[#A1A1AA] text-base leading-[1.4] max-w-[200px]">
                {stat.label}
              </div>
            </motion.div>
          ))}
        </div>

        <div className="font-mono text-xs text-[#71717A] italic">
          One brand, six months of data. Every brand has a version of this.
        </div>
      </div>
    </section>
  );
}
